import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService {
  constructor(public jwtHelper: JwtHelperService) {}

  private excludedUrls = [
    `${environment.ENGINE_API_URL}/filestore/upload/doc`,
    `${environment.ENGINE_API_URL}/service-requests/with-files`,
    `${environment.ENGINE_API_URL}/service-requests/ccdf`,
  ];
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token') || localStorage.getItem('access_token');

    const shouldExclude = this.excludedUrls.some((url) => request.url.includes(url));

    if (shouldExclude) {
      // Passez la requête telle quelle sans ajout de token
      return next.handle(request);
    }

    let modifiedRequest = request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });

    if (token) {
      try {
        let isExpired = false;
        if (token.includes('.')) {
          isExpired = this.jwtHelper.isTokenExpired(token);
        } else {
          const decoded = JSON.parse(atob(token));
          isExpired = decoded.expiresAt ? decoded.expiresAt < Date.now() : true;
        }

        if (!isExpired) {
          modifiedRequest = modifiedRequest.clone({
            setHeaders: {
              // Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du token:', error);
      }
    }

    return next.handle(modifiedRequest);
  }
}
